import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import Layout from "./components/Topbar";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProductList from "./pages/ProductList";
import QuotationBuilder from "./pages/QuotationBuilder";
import QuotationHistory from "./pages/QuotationHistory";
import StaffManagement from "./pages/StaffManagement";
import ProductCatalog from "./pages/ProductCatalog";
import QuotationForm from "./pages/QuotationForm";
import ProformaInvoiceHistory from "./pages/ProformaInvoiceHistory";
import EditQuotation from "./pages/EditQuotation";
import Inventory from "./pages/Inventory";
import StockDisplay from "./pages/StockDisplay";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/products"
            element={
              <ProtectedRoute role={["admin", "manager"]}>
                <Layout>
                  {/* <ProductList /> */}
                  <ProductCatalog />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotation/new"
            element={
              <ProtectedRoute>
                <Layout>
                  {/* <QuotationBuilder /> */}
                  <QuotationForm />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotation/history"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuotationHistory />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotation/edit/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <EditQuotation />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/proforma-invoices"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProformaInvoiceHistory />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/staff"
            element={
              <ProtectedRoute role={["admin", "manager"]}>
                <Layout>
                  <StaffManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute role={["admin", "manager"]}>
                <Layout>
                  <Inventory />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-display"
            element={
              <ProtectedRoute>
                <Layout>
                  <StockDisplay />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

// // src/App.tsx
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { AuthProvider } from "./context/AuthContext";
// import ProtectedRoute from "./routes/ProtectedRoute";
// import Layout from "./components/Topbar";

// import Login from "./pages/Login";
// import Dashboard from "./pages/Dashboard";
// import ProductList from "./pages/ProductList";
// import QuotationBuilder from "./pages/QuotationBuilder";
// import QuotationHistory from "./pages/QuotationHistory";
// import StaffManagement from "./pages/StaffManagement";
// import ProductCatalog from "./pages/ProductCatalog";
// import QuotationForm from "./pages/QuotationForm";
// import ProformaInvoiceHistory from "./pages/ProformaInvoiceHistory";
// import EditQuotation from "./pages/EditQuotation";

// function App() {
//   return (
//     <AuthProvider>
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<Login />} />

//           <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <Dashboard />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/products"
//             element={
//               <ProtectedRoute role={["admin", "manager"]}>
//                 <Layout>
//                   {/* <ProductList /> */}
//                   <ProductCatalog />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/quotation/new"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   {/* <QuotationBuilder /> */}
//                   <QuotationForm />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/quotation/history"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <QuotationHistory />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/proforma-invoices"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <ProformaInvoiceHistory />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/staff"
//             element={
//               <ProtectedRoute role={["admin", "manager"]}>
//                 <Layout>
//                   <StaffManagement />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />
//         </Routes>
//         <Route
//           path="/quotation/edit/:id"
//           element={
//             <ProtectedRoute>
//               <Layout>
//                 <EditQuotation />
//               </Layout>
//             </ProtectedRoute>
//           }
//         />
//       </BrowserRouter>
//     </AuthProvider>
//   );
// }

// export default App;

